import { EntryRef } from "../../schema/sys";
import { ContributorEntry } from "../../schema/semantics";
import { createArticleContributorProps } from "./article-contributors.props";
import { ContributorProps } from "design-system/components/primitives/contributors/contributors";
import { ArticleFooterContributorInfoProps } from "design-system/components/pages/article-page/article-footer/article-footer-contributor-info";
export type { ContributorProps };

interface Contributors {
  [key: string]: Array<ArticleFooterContributorInfoProps>;
}

export const ContentfulContributorsProps = (
  entries: Array<EntryRef<ContributorEntry>>,
): Contributors => {
  const contributors: Contributors = {};
  const seenTypes = new Set<string>();

  for (const entry of entries) {
    const entryProps = createArticleContributorProps(entry);
    if (!entryProps) continue;

    const types = entryProps.type ?? [];
    for (const type of types) {
      seenTypes.add(type);

      if (!contributors[type]) {
        contributors[type] = [];
      }
      contributors[type].push(entryProps);
    }
  }

  return contributors;
};
